import { FastForward } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Container, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './style.css';

const StatusAnalista = ({
  fund,
  count, // margin
  countAwaitingComprovations, //
  countAR,
  countReceipt,
  loading
}) => {
  const [i, setI] = useState(0);

  useEffect(()=>{
    setI(Math.floor(Math.random() * 6));
  },[])

  const { t } = useTranslation();

  const getColor = (key) => {
    return [
      '#58DB51',
      '#048DD6',
      '#0FD6B1',
      '#0A5D8A',
      '#D61A26',
      '#038A70'
    ][key];
  }

  const getValues = (v) => {
    return v.map((a,k)=>{
      return (
        <Col className="p-2" >
          <Card className="shadow bg-white rounded black">
            <Card.Body className="nav-card p-3">
              <div className="nav-card-img-left">
              {a.img?a.img:''}
              </div>
              <div className="nav-card-name">{a.name}</div>
              <div className="nav-card-value">
                {!loading ? a.value : (<>
                  <Spinner animation="border" style={{ color: '#e05c17' }}  />
                </>)}
              </div>
            </Card.Body>
          </Card>
        </Col>
      );
    })
  };

  return (
    <>
      {getValues([
        {name:t('title:fund'),value:fund.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),img:<img src="/money.png"/>},
        {name:t('label:margin'),value:count.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),img:<img src="/coin.png"/>},
        {name:t('label:awaiting comprovations'),value:countAwaitingComprovations.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),img:<img src="/list.png"/>},
        {name:t('label:await receipt'),value:countAR.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),img:<img src="/paid-color.png"/>},
        {name:t('statuses:finished'),value:countReceipt.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),img:<img src="/pay.png"/>},
      ])}
    </>
  );
};

export default StatusAnalista;
